import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Button, Icon } from 'semantic-ui-react'

const FetchFailedCardHeader = ({ customerName, operatingContractBrewerCustomerId }) => {
  const { t: translate } = useTranslation('common')
  let displayedCustomerName
  if (customerName) {
    displayedCustomerName = customerName
  } else {
    displayedCustomerName = operatingContractBrewerCustomerId
      ? translate('Brewer')
      : translate('Child Account')
  }

  return (
    <Card.Header className="semantic-ui-error-text-color">
      {`${translate('failedToLoad')} ${displayedCustomerName}`}
    </Card.Header>
  )
}

const FetchFailedCardDescription = ({ customerName, operatingContractBrewerCustomerId }) => {
  const { t: translate } = useTranslation('common')
  let displayedCustomerName

  if (customerName) {
    displayedCustomerName = customerName
  } else {
    displayedCustomerName = operatingContractBrewerCustomerId
      ? translate('this brewer')
      : translate('this child account')
  }

  const text = `${translate('errorLoadingDashboard1')} ${displayedCustomerName}. ${translate('errorLoadingDashboard2')}`

  return <Card.Description>{text}</Card.Description>
}

const FetchFailedCardMainContent = ({ customerName, operatingContractBrewerCustomerId }) => (
  <Card.Content>
    <FetchFailedCardHeader
      customerName={customerName}
      operatingContractBrewerCustomerId={operatingContractBrewerCustomerId}
    />
    <FetchFailedCardDescription
      customerName={customerName}
      operatingContractBrewerCustomerId={operatingContractBrewerCustomerId}
    />
  </Card.Content>
)

export default ({
  customerName,
  operatingContractBrewerCustomerId,
  retryFetchCustomerPrelimInfo,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <Card centered color="red" className="centered-content">
      <FetchFailedCardMainContent
        customerName={customerName}
        operatingContractBrewerCustomerId={operatingContractBrewerCustomerId}
      />
      <Card.Content extra>
        <Button fluid animated onClick={retryFetchCustomerPrelimInfo}>
          <Button.Content visible>{translate('Reload')}</Button.Content>
          <Button.Content hidden>
            <Icon name="refresh" />
          </Button.Content>
        </Button>
      </Card.Content>
    </Card>
  )
}
